import { fromJS } from 'immutable';

export default {
    setHomeProductsInitialized: (state, homeId) => {
        return state.setIn(['list', homeId, 'productsInitialized'], true);
    },
    setHomes: (state, homes) => {
        return state.setIn(['list'], fromJS(homes)).set('initialized', true);
    },
    setHistoryActions: (state, historyActions) => {
        return state.set('historyActions', fromJS(historyActions));
    },
    updateHomes: (state, homes) => {
        return state.mergeDeepIn(['list'], fromJS(homes));
    },
    updateHome: (state, homeId, homeDetails) => {
        return state.mergeDeepIn(['list', homeId], fromJS(homeDetails));
    },
    updateHomeGenerators: (state, homeId, homeGenerators) => {
        return state.mergeDeepIn(['list', homeId, 'generators'], fromJS(homeGenerators));
    },
    deleteHomeGenerator: (state, homeId, generatorId) => {
        return state.deleteIn(['list', homeId, 'generators', generatorId]);
    },
    homeDelete: (state, { homeId }) => {
        return state.deleteIn(['list', String(homeId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Homes/core.js